import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./iconSelector.scss";
import {
  faBurgerSoda,
  faUtensils,
  faSalad,
  faPopcorn,
  faPlateUtensils,
  faFrenchFries,
  faForkKnife,
  faEgg,
  faCupStraw,
  faCupStrawSwoosh,
  faCarrot,
  faBacon,
  faFish,
  faBurrito,
  faWineBottle,
  faWineGlass,
  faWhiskeyGlass,
  faWhiskeyGlassIce,
  faTaco,
  faSoftServe,
  faSushiRoll,
  faSausage,
  faSandwich,
  faPretzel,
  faPizza,
  faPizzaSlice,
  faPancakes,
  faMug,
  faMartiniGlass,
  faIceCream,
  faHotdog,
  faHatChef,
  faCupTogo,
  faCoffeePot,
  faCheeseSwiss,
  faChampagneGlasses,
  faBowlHot,
  faBowlRice,
  faBagel,
  faBeerMug,
  faGolfFlagHole,
  faGolfClub,
  faGolfBallTee,
  faFolder,
  faFolderXmark,
  faFolderUser,
  faFolderPlus,
  faFolderMusic,
  faFolderMinus,
  faFolderMedical,
  faFolderMagnifyingGlass,
  faFolderImage,
  faFolderHeart,
  faFolderGrid,
  faFolderGear,
  faFolderBookmark,
  faFolderArrowUp,
  faFolderArrowDown,
  faStar,
  faPaperclip,
  faCartShopping,
  faCar,
  faGift,
  faUmbrella,
  faTag,
  faBarcode,
  faKey,
  faTicket,
  faSnowflake,
  faGamepad,
  faSun,
  faBagShopping,
  faBedFront,
  faGauge,
  faCarSide,
  faCableCar,
  faClock,
  faCashRegister,
  faFlagCheckered,
  faAward,
  faWrench,
  faTrophy,
  faHammer,
  faCoins,
  faFlag,
  faRingsWedding,
  faTablePicnic,
  faPersonSkiing,
  faShirt,
  faShirtRunning,
  faShirtLongSleeve,
  faHatCowboy,
  faIdCardClip,
  faTimes,
} from "@fortawesome/pro-regular-svg-icons";
import Input from "components/form/input/Input";

interface IEmojiGridProps {
  onIconSelect: (icon: string) => void;
  selectedIcon?: string; // Add prop for pre-selected icon
}

export const allIcons = {
  [faBurgerSoda.iconName]: faBurgerSoda,
  [faUtensils.iconName]: faUtensils,
  [faSalad.iconName]: faSalad,
  [faPopcorn.iconName]: faPopcorn,
  [faPlateUtensils.iconName]: faPlateUtensils,
  [faFrenchFries.iconName]: faFrenchFries,
  [faForkKnife.iconName]: faForkKnife,
  [faEgg.iconName]: faEgg,
  [faCupStraw.iconName]: faCupStraw,
  [faCupStrawSwoosh.iconName]: faCupStrawSwoosh,
  [faCarrot.iconName]: faCarrot,
  [faBacon.iconName]: faBacon,
  [faFish.iconName]: faFish,
  [faBurrito.iconName]: faBurrito,
  [faWineBottle.iconName]: faWineBottle,
  [faWineGlass.iconName]: faWineGlass,
  [faWhiskeyGlass.iconName]: faWhiskeyGlass,
  [faWhiskeyGlassIce.iconName]: faWhiskeyGlassIce,
  [faTaco.iconName]: faTaco,
  [faSoftServe.iconName]: faSoftServe,
  [faSushiRoll.iconName]: faSushiRoll,
  [faSausage.iconName]: faSausage,
  [faSandwich.iconName]: faSandwich,
  [faPretzel.iconName]: faPretzel,
  [faPizza.iconName]: faPizza,
  [faPizzaSlice.iconName]: faPizzaSlice,
  [faPancakes.iconName]: faPancakes,
  [faMug.iconName]: faMug,
  [faMartiniGlass.iconName]: faMartiniGlass,
  [faIceCream.iconName]: faIceCream,
  [faHotdog.iconName]: faHotdog,
  [faHatChef.iconName]: faHatChef,
  [faCupTogo.iconName]: faCupTogo,
  [faCoffeePot.iconName]: faCoffeePot,
  [faCheeseSwiss.iconName]: faCheeseSwiss,
  [faChampagneGlasses.iconName]: faChampagneGlasses,
  [faBowlHot.iconName]: faBowlHot,
  [faBowlRice.iconName]: faBowlRice,
  [faBagel.iconName]: faBagel,
  [faBeerMug.iconName]: faBeerMug,
  [faGolfFlagHole.iconName]: faGolfFlagHole,
  [faGolfClub.iconName]: faGolfClub,
  [faGolfBallTee.iconName]: faGolfBallTee,
  [faFolder.iconName]: faFolder,
  [faFolderXmark.iconName]: faFolderXmark,
  [faFolderUser.iconName]: faFolderUser,
  [faFolderPlus.iconName]: faFolderPlus,
  [faFolderMusic.iconName]: faFolderMusic,
  [faFolderMinus.iconName]: faFolderMinus,
  [faFolderMedical.iconName]: faFolderMedical,
  [faFolderMagnifyingGlass.iconName]: faFolderMagnifyingGlass,
  [faFolderImage.iconName]: faFolderImage,
  [faFolderHeart.iconName]: faFolderHeart,
  [faFolderGrid.iconName]: faFolderGrid,
  [faFolderGear.iconName]: faFolderGear,
  [faFolderBookmark.iconName]: faFolderBookmark,
  [faFolderArrowUp.iconName]: faFolderArrowUp,
  [faFolderArrowDown.iconName]: faFolderArrowDown,
  [faStar.iconName]: faStar,
  [faPaperclip.iconName]: faPaperclip,
  [faCartShopping.iconName]: faCartShopping,
  [faCar.iconName]: faCar,
  [faGift.iconName]: faGift,
  [faUmbrella.iconName]: faUmbrella,
  [faTag.iconName]: faTag,
  [faBarcode.iconName]: faBarcode,
  [faKey.iconName]: faKey,
  [faTicket.iconName]: faTicket,
  [faSnowflake.iconName]: faSnowflake,
  [faGamepad.iconName]: faGamepad,
  [faSun.iconName]: faSun,
  [faBagShopping.iconName]: faBagShopping,
  [faBedFront.iconName]: faBedFront,
  [faGauge.iconName]: faGauge,
  [faCarSide.iconName]: faCarSide,
  [faCableCar.iconName]: faCableCar,
  [faClock.iconName]: faClock,
  [faCashRegister.iconName]: faCashRegister,
  [faFlagCheckered.iconName]: faFlagCheckered,
  [faAward.iconName]: faAward,
  [faWrench.iconName]: faWrench,
  [faTrophy.iconName]: faTrophy,
  [faHammer.iconName]: faHammer,
  [faCoins.iconName]: faCoins,
  [faFlag.iconName]: faFlag,
  [faRingsWedding.iconName]: faRingsWedding,
  [faTablePicnic.iconName]: faTablePicnic,
  [faPersonSkiing.iconName]: faPersonSkiing,
  [faShirt.iconName]: faShirt,
  [faShirtRunning.iconName]: faShirtRunning,
  [faShirtLongSleeve.iconName]: faShirtLongSleeve,
  [faHatCowboy.iconName]: faHatCowboy,
  [faIdCardClip.iconName]: faIdCardClip,
};

const EmojiGrid: React.FC<IEmojiGridProps> = ({ onIconSelect, selectedIcon }) => {
  const [recentlyUsed, setRecentlyUsed] = useState<string | null>(selectedIcon || null);

  useEffect(() => {
    setRecentlyUsed(selectedIcon || null);
  }, [selectedIcon]);

  const [searchIcons, setSearchIcons] = useState<string>("");

  // Function to handle icon selection and update the recently used icon
  const handleIconClick = (iconLabel: string) => {
    setRecentlyUsed(iconLabel);
    onIconSelect(iconLabel);
  };

  // Function to handle deselecting an icon
  const handleDeselectIcon = (e: React.MouseEvent) => {
    e.stopPropagation();
    setRecentlyUsed(null);
    onIconSelect("");
  };

  // Filter icons based on the search term
  const filteredIcons = Object.keys(allIcons).filter(iconName =>
    iconName.toLowerCase().includes(searchIcons.toLowerCase()),
  );

  return (
    <>
      <div className="search-container">
        <Input
          placeholder={t("Search icons...")}
          onSearchClear={() => setSearchIcons("")}
          value={searchIcons}
          onChange={e => setSearchIcons(e.target.value)}
        />
      </div>

      <div className="emoji-grid-container">
        {/* All Icons in a single grid */}
        <div className="emoji-grid">
          {filteredIcons.map((item, index) => (
            <div
              key={index}
              className={`emoji-item ${recentlyUsed === item ? "selected" : ""}`}
              onClick={() => handleIconClick(item)}
            >
              <FontAwesomeIcon icon={allIcons[item]} size="1x" />
              {recentlyUsed === item && (
                <div className="deselect-x" onClick={handleDeselectIcon}>
                  <FontAwesomeIcon icon={faTimes} size="xs" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default EmojiGrid;
